import { ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'

import s from './styles.module.scss'

interface Props extends DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> {
  leftIcon?: boolean
  content?: string
}

export const ButtonAddCircle: FC<Props> = ({ leftIcon, content, ...props }) => {
  return (
    <button
      className={s.button}
      {...props}
    >
      {leftIcon && (
        <AppIcon
          width={24}
          height={24}
          id={AllIcons.PLUS}
          className={s.icon}
        />
      )}
      {content}
    </button>
  )
}
